import { useComputedCallback } from '../utils/useComputedCallback';
import { computed } from 'vue';
import { matchPath } from '../api/matchPath';
import { useRouteContext } from '../hooks/useOutlet';
export const useMatch = (patternValue) => {
    const pattern = useComputedCallback(patternValue);
    const context = useRouteContext();
    const match = computed(() => matchPath(pattern.value, context.pathname));
    return match;
};
